// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3wJgB","list":"styles_list__2caDG"};